import { Component } from '@angular/core';

@Component({
  selector: 'category-icon',
  standalone: true,
  imports: [],
  templateUrl: './category.component.html',
  styleUrl: './category.component.scss'
})
export class CategoryIcon {}
